<template>
    <div v-if="!dataEmpty">
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><router-link to="/national-report">Home</router-link></li>
			<li class="breadcrumb-item active">Log Report Detail</li>
		</ol>

        <h1 class="page-header">Log Report Detail</h1>
        <hr>

        <div class="mt-3 border border-danger" style="background-color: #1f2225;padding: 15px 4px;color:white;font-weight:bold;font-size:15px;overflow-x:scroll">
            <div class="row">
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        RQUUID
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        {{data.rq_uuid}}
                    </div>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        Total Vehicle
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        {{data.total_vehicle}}
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        Status
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5" v-if="data.status == 'Failed'" style="color:#ff7152">
                        {{data.status.toUpperCase()}}
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5" v-else style="color:#68edb6">
                        {{data.status.toUpperCase()}}
                    </div>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5">
                        # Success
                    </div>
                    <div class="col-sm-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5">
                        {{data.success}}
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5">
                        Created Date
                    </div>
                    <div class="col-sm-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5">
                        {{data.date.toISOString().replace("T" , " ").slice(0,19)}}
                    </div>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4 row">
                    <div class="col-sm-5 col-xs-5">
                        # Failed
                    </div>
                    <div class="col-sm-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5">
                        {{data.failed}}
                    </div>
                </div>

            </div>
        </div>

        <reportLogDetailTable class="mt-4" :rq_uuid="$route.params.rquuid"></reportLogDetailTable>
    </div>
</template>

<script>
import reportLogDetailTable from './childComponents/reportLogDetailTable'

export default {
    components : {
        reportLogDetailTable
    },
    data(){
        return{
            data : this.$route.params.data,
            options : { year: 'numeric', month: 'long', day: 'numeric' },
            dataEmpty : true
        }
    },
    mounted(){
        if(!this.data){
            var url = "/api/log/report/" + this.$route.params.rquuid;
            this.$http.get(url)
            .then((resp)=>{
         
                console.log(resp.data.data);

                this.data = resp.data.data;
                this.data.date = new Date(this.data.date)
                this.dataEmpty = false;
            })
            .catch((err)=>{
                console.log(err);
            })
        }
        else
            this.dataEmpty = false;
    }
}
</script>

<style>

</style>